import styled, { css } from 'styled-components';

import { ASSET_PATH } from 'assetsPath';

export const Field = styled.div`
    display:flex;
    width:${(props) => props.$width ? props.$width : '300px'};
    height: ${(props) => props.$height ? props.$height : '48px'};
    border:1px solid ${(props) => props.borderColor ? props.borderColor : '#ccc'};
    border-radius:4px;
    position:relative;
		background: ${(props) => props.background ? props.background : 'transparent'};
    & input[type="text"]{
        width: 100%;
        border: 0;
        padding-left: 30px;
        padding-right:10px;
        outline: 0;
        background: transparent;
        color:#777777;
        font-size:14px;
    }
		&.travSuggest {
			.search-ico {
				right: 10px;
				left: auto;
				top:10px;
			}
			input {
				font-size: 18px;
				font-weight: 800;
			}
			border-radius: 8px;
		}
		&.orgAddress{
			input[type='text'] {
				padding-left: 12px;
				color:#000;
			}
			height: 48px;
		}
		.searchBtn {
			max-height: 48px;
			width: 75px;
			padding: 14px 0;
			position: absolute;
			right: 0;
			top: -1px;
			border-radius: 0 4px 4px 0;
			font-size: 14px;
			box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.2);
		}
		&.budgetSearch {
			align-items: center;
			.search-ico{
				top: 10px;
			}
			border-radius: 8px;
			margin-right: 16px;
		}
`;

export const TextInfo = styled.span`
    font-size: 11px;
    color: #666;
    position: absolute;
    top: 106%;
`;
